import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, TextField, InputLabel, Select, MenuItem, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import MUIDataTable from 'mui-datatables';
import Edit from '@material-ui/icons/Edit';
import TrashIcon from '@material-ui/icons/Delete';
import LongMenu from '../share/LongMenu';
import FormDialogPrestadorEspecialidades from './FormDialogPrestadorEspecialidades';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  textFieldNome: {
    width: 490,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit * 0.5,
  },
  textFieldNumRegistro: {
    width: 290,
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit * 0.5,
  },
  selectUF: {
    margin: theme.spacing.unit,
    width: 250,
  },
  buttonAdicionarPrestador: {
    margin: theme.spacing.unit,
  },
  divAdicionarPrestador: {
    textAlign: 'center'
  },
});
class FormDialogProfissional extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.profissional,
      fetching: false,
      errorMessageNome: '',
      errorMessageNumRegistro: '',
      profissional: this.props.profissional,
      especialidades: this.props.especialidades,
      UFs: this.props.UFs,
      openDialog: false,
      profissionalPrestadores: this.props.profissionalPrestadores,
      profissionalPrestadorSelecionado: {},
      anchorEl: null,
      tableMeta: {},
      modoInclusaoEspecialidade: true,
      snackOpen: false,
      snackMessage: '',
      sucesso: false
    };
  }
  handleClickSave = async () => {
    let profissionalPrestadores = [];
    for (var i = 0; i < this.state.profissionalPrestadores.length; i++) {
      let profissionalPrestador = {
        seqRegistroPrestador: this.state.profissionalPrestadores[i][0],
        seqPrestador: this.state.profissionalPrestadores[i][1],
        nomePrestador: this.state.profissionalPrestadores[i][2],
        dtaInicio: format(new Date(this.state.profissionalPrestadores[i][3]), 'YYYY-MM-DD'),
        dtaFim: this.state.profissionalPrestadores[i][4] === null ? null : format(new Date(this.state.profissionalPrestadores[i][4]), 'YYYY-MM-DD'),
        desEspecialidades: this.state.profissionalPrestadores[i][5],
      };
      profissionalPrestadores.push(profissionalPrestador);
    }
    const profissional = {
      seqProfissional: this.state.seqProfissional === undefined ? 0 : this.state.seqProfissional,
      numRegistro: this.state.numRegistro,
      codConselho: this.state.codConselho === undefined ? 'CRO' : this.state.seqProfissional,
      siglaConselho: this.state.seqUF,
      nome: this.state.nome === undefined ? '' : this.state.nome,
      profissionalPrestador: profissionalPrestadores,
    };
    await this.props.handleSave(profissional);
  }
  handleClickAdicionarPrestador = async () => {
    this.setState({openDialog: true, profissionalPrestadorSelecionado: {}, modoInclusaoEspecialidade: true});
  }
  handleCloseAdicionarPrestador = async () => {
    this.setState({openDialog: false});
  }
  handleChangeTextField = event => {
    if (event.target.name === 'nome') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase(), errorMessageNome: '' });
    }
  };
  handleBlurNome = () => {
    if (this.state.nome === '' || this.state.nome === null || this.state.nome === undefined) {
      this.setState({errorMessageNome: 'Favor preencher o Nome'});
    } else {
      this.setState({errorMessageNome: ''});
    }
  }
  handleChangeTextFieldNumRegistro = event => {
    if (event.target.name === 'numRegistro') {
      this.setState({ [event.target.name]: event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 6) });
    }
  };
  handleBlurNumRegistro = () => {
    if (this.state.numRegistro === '' || this.state.numRegistro === null || this.state.numRegistro === undefined) {
      this.setState({errorMessageNumRegistro: 'Favor preencher o Número'});
    } else {
      this.setState({errorMessageNumRegistro: ''});
    }
  }
  handleChangeSelectUF = event => {
    this.setState({ seqUF: event.target.value });
  };
  handleClickExcluir = () => {
    if (this.state.profissional.profissionalPrestador[this.state.tableMeta.rowIndex][0] === 0) {
      let profissional = this.state.profissional;
      let profissionaisPrestadores = profissional.profissionalPrestador;
      profissionaisPrestadores.splice(this.state.tableMeta.rowIndex, 1);
      profissional.profissionalPrestador = profissionaisPrestadores;
      this.setState({ profissional: profissional });
    } else {
      this.setState({ snackOpen: true, sucesso: false, snackMessage: 'Este item não pode ser excluído pois já está sendo referenciado.' });
    }
  };
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  handleClickMenu = (event, tableMeta) => {
    let profissionalPrestadorSelecionado = {
      seqRegistroPrestador: this.state.profissionalPrestadores[tableMeta.rowIndex][0],
      seqPrestador: this.state.profissionalPrestadores[tableMeta.rowIndex][1],
      nomePrestador: this.state.profissionalPrestadores[tableMeta.rowIndex][2],
      dtaInicio: format(new Date(this.state.profissionalPrestadores[tableMeta.rowIndex][3]), 'YYYY-MM-DD'),
      dtaFim: this.state.profissionalPrestadores[tableMeta.rowIndex][4] === null ? null : format(new Date(this.state.profissionalPrestadores[tableMeta.rowIndex][4]), 'YYYY-MM-DD'),
      desEspecialidades: this.state.profissionalPrestadores[tableMeta.rowIndex][5],
    };
    this.setState({ anchorEl: event.currentTarget, profissionalPrestadorSelecionado: profissionalPrestadorSelecionado, tableMeta: tableMeta });
  }
  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }
  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialog: true, tituloFormDialog: 'Alteração de Prestador/Especialidades', modoInclusaoEspecialidade: false});
    }
    if (index === 1) {
      this.handleClickExcluir();
    }
  }

  handleSaveAdicionarPrestador = (prestador) => {
    let profissionalPrestadores = this.state.profissionalPrestadores;
    if (this.state.modoInclusaoEspecialidade) {
      if (profissionalPrestadores === undefined) {
        profissionalPrestadores = prestador;
      } else {
        profissionalPrestadores.push(prestador);
      }
    } else {
      let profissional = this.state.profissional;
      let profissionaisPrestadores = profissional.profissionalPrestador;
      profissionaisPrestadores.splice(this.state.tableMeta.rowIndex, 1);
      profissional.profissionalPrestador = profissionaisPrestadores;
      this.setState({ profissional: profissional });
      profissionalPrestadores.push(prestador);
    }
    this.setState({openDialog: false, profissionalPrestadores: profissionalPrestadores});
  }

  isSalvarDisabled = () => {
    return (this.state.seqPrestadorSelected === 0 ||
    this.state.from === '' ||
    this.state.especialidadesSelectedComNome.length === 0);
  }

  isSalvarDisabled = () => {
    return (this.state.errorMessageNome !== '' ||
    this.state.nome === undefined ||
    this.state.nome === '') ||

    (this.state.errorMessageNumRegistro !== '' ||
    this.state.numRegistro === undefined ||
    this.state.numRegistro === '') ||

    (this.state.seqUF === 0 ||
      this.state.seqUF === undefined) ||

    (this.state.profissionalPrestadores === undefined ||
      this.state.profissionalPrestadores.length === 0);
  }

  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 5,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>prestador(es) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Código Prestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome Prestador',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Data de início',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Data Final',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Especialidades',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <Edit />,
                primaryText: 'Editar Especialidades...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <TrashIcon />,
                primaryText: 'Excluir Especialidades...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                disabled={this.props.modoInclusao}
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
    ];
    const { classes, open, handleClose, titulo, prestadores } = this.props;
    const { profissionalPrestadores } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          <DialogContent>
            <Paper className={classes.paper}>
              <FormControl>
                <TextField
                  autoFocus
                  disabled={!this.props.isEditavel}
                  id='nome'
                  name='nome'
                  value={this.state.nome}
                  margin='dense'
                  fullWidth
                  onChange={this.handleChangeTextField}
                  className={classes.textFieldNome}
                  error={this.state.errorMessageNome !== ''}
                  label={this.state.errorMessageNome !== '' ? this.state.errorMessageNome : '* Nome'}
                  onBlur={this.handleBlurNome}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  disabled={!this.props.isEditavel}
                  id='numRegistro'
                  name='numRegistro'
                  value={this.state.numRegistro}
                  margin='dense'
                  fullWidth
                  onChange={this.handleChangeTextFieldNumRegistro}
                  className={classes.textFieldNumRegistro}
                  error={this.state.errorMessageNumRegistro !== ''}
                  label={this.state.errorMessageNumRegistro !== '' ? this.state.errorMessageNumRegistro : '* Número Registro CRO'}
                  onBlur={this.handleBlurNumRegistro}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectUF}>
                  UF
                </InputLabel>
                <Select
                  className={classes.selectUF}
                  value={this.state.seqUF}
                  onChange={this.handleChangeSelectUF}
                  inputProps={{
                    name: 'seqUF',
                  }}
                >
                  {this.state.UFs.map((Uf, idx) => {
                    return (<MenuItem key={idx} value={Uf.id}>{Uf.nome}</MenuItem>);
                  })}
                </Select>
              </FormControl>
            </Paper>
            <Paper>
              <div className={classes.divAdicionarPrestador}>
                <Button
                  color='primary'
                  variant='contained'
                  className={classes.buttonAdicionarPrestador}
                  onClick={this.handleClickAdicionarPrestador}
                  id={'adicionarPrestador'}>
                  Adicionar Prestador
                </Button>
              </div>
              <MUIDataTable
                data={profissionalPrestadores}
                columns={columns}
                options={options}
              />
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        {this.state.openDialog &&
        <FormDialogPrestadorEspecialidades
          open={this.state.openDialog}
          handleClose={this.handleCloseAdicionarPrestador}
          handleSave={this.handleSaveAdicionarPrestador}
          prestadores={prestadores}
          especialidades={this.state.especialidades}
          titulo={'Adicionar Prestador/Especialidades'}
          profissionalPrestador={this.state.profissionalPrestadorSelecionado}
          modoInclusao={this.state.modoInclusaoEspecialidade} />}
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogProfissional);
